import type { GameLinkView } from '#src/interfaces/gameManager'
import { getGameDisplayName, getGameThumbnail, getGameUrls } from '#src/utils/gameUtils'
import { computed, toValue, type MaybeRefOrGetter } from 'vue'

export interface FormattedGameView {
  gameId: string
  linkCode: string
  gameDisplayId: string
  gameDisplayName: string
  thumbnail: string | undefined
  ssbtUrl: string | undefined
  posUrl: string | undefined
}

export const useGamesList = (gameLinksInput: MaybeRefOrGetter<GameLinkView[]>) => {
  const formattedGames = computed<FormattedGameView[]>(() => {
    const links = toValue(gameLinksInput)

    return links.map((gameLink) => {
      const { game } = gameLink.installation
      const urls = getGameUrls(game)

      return {
        gameId: String(game.id),
        linkCode: gameLink.code,
        gameDisplayId: game.displayId,
        gameDisplayName: getGameDisplayName(gameLink),
        thumbnail: getGameThumbnail(game),
        ssbtUrl: urls.ssbtUrl,
        posUrl: urls.posUrl
      }
    })
  })

  return {
    formattedGames
  }
}
